const ProvenFactors = () => {
  return <div>ProvenFactors</div>;
};

export default ProvenFactors;
